"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.statusCardSchema = void 0;
const zod_1 = __importDefault(require("zod"));
exports.statusCardSchema = zod_1.default.record(zod_1.default.string(), zod_1.default.record(zod_1.default.string(), zod_1.default.object({
    tests: zod_1.default.object({
        aa: zod_1.default.number(),
        ab: zod_1.default.number(),
        predictive: zod_1.default.number(),
        multipage: zod_1.default.number(),
        multivariate: zod_1.default.number(),
    }),
    personalization: zod_1.default.object({
        mep: zod_1.default.number(),
        mpp: zod_1.default.number(),
        sp: zod_1.default.number(),
    }),
    patch: zod_1.default.object({
        patch: zod_1.default.number(),
        mtpp: zod_1.default.number(),
    }),
})));
//# sourceMappingURL=schemas.js.map